export const PRICE_REQUEST_INLINE_CTA_COOKIE = 'klg.features.QTpriceRequestInlineCTAExperiment';
